export enum PatchAttachmentsFormFields {
    Attachments = 'attachments',
}
